// extracted by mini-css-extract-plugin
module.exports = {"success-block":"_3ea6fa5da8--success-block--uRtP1","mobile-content":"_3ea6fa5da8--mobile-content--DUuhf","text-wrapper":"_3ea6fa5da8--text-wrapper--w5ipO"};